import api from "./api";

// 挑战赛列表
export const postChallengeMatchList = params => {
  return api('post', `/v1/management/challengeMatch/challengeMatchList`, params);
};

// 挑战赛新增
export const createChallengeMatch = params => {
  return api('post', `/v1/management/challengeMatch/create`, params);
};

// 挑战赛修改
export const updateChallengeMatch = params => {
  return api('post', `/v1/management/challengeMatch/update`, params);
};

// 挑战赛详情
export const fetchChallengeMatch = id => {
  return api('get', `/v1/management/challengeMatch/details/${id}`);
};

// 挑战赛发布
export const publish = id => {
  return api('get', `/v1/management/challengeMatch/publish/${id}`);
};

// 挑战赛下架
export const soldOut = id => {
  return api('get', `/v1/management/challengeMatch/soldOut/${id}`);
};

// 挑战赛删除
export const deleteChallengeMatch = id => {
  return api('get', `/v1/management/challengeMatch/delete/${id}`);
};

// 挑战赛开奖
export const lotteryUserLottery = (params) => {
  return api('post', `/v1/management/lottery/userLottery`, params);
};

// 挑战赛下载中奖名单
export const lotteryDownload = ({ objectType, objectId }) => {
  return api('get', `/v1/management/lottery/lotteryDownload/${objectType}/${objectId}`,
    {},
    {
      responseType: "blob",
    }
  );
};

// 显示中奖公示
export const challengeMatchShowLottery = (id) => {
  return api('get', `/v1/management/challengeMatch/showLottery/${id}`);
};
